export default __webpack_public_path__ + "static/media/view.cba40afb.svg";